module.exports = __webpack_public_path__ + "static/media/sha1.31eb87ce.webp";